import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

// Demande, une seule fois, aux techniciens (pas aux gestionnaires ni
// investisseurs) leur niveau d'expérience — pour adapter le niveau
// d'accompagnement sur l'écran de rapport. Les comptes techniciens déjà
// existants sont dispensés automatiquement (considérés expérimentés).
const NiveauAgronomeGate = ({ children }) => {
  const { utilisateur } = useAuth();
  const [statut, setStatut] = useState(null);
  const [envoi, setEnvoi] = useState(false);

  const estTechnicien = utilisateur?.role === 'technicien' || utilisateur?.role === 'tech_invest';

  useEffect(() => {
    if (!estTechnicien) {
      setStatut({ niveau_agronome: 'experimente' });
      return;
    }
    api.get('/auth/moi')
      .then(res => setStatut({ niveau_agronome: res.data.niveau_agronome }))
      .catch(() => setStatut({ niveau_agronome: 'experimente' }));
  }, [estTechnicien]);

  const choisir = async (niveau) => {
    setEnvoi(true);
    try {
      await api.post('/auth/niveau-agronome', { niveau });
      setStatut({ niveau_agronome: niveau });
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setEnvoi(false);
    }
  };

  if (statut === null) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-400 text-sm">Chargement...</div>
      </div>
    );
  }

  if (statut.niveau_agronome) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center px-6">
      <div className="max-w-md mx-auto w-full">
        <h1 className="text-lg font-medium text-gray-900 mb-2">Une dernière chose 👋</h1>
        <p className="text-sm text-gray-600 mb-6">
          Pour mieux vous accompagner sur les rapports, êtes-vous nouveau dans ce métier ou déjà expérimenté ?
        </p>

        <button onClick={() => choisir('nouveau')} disabled={envoi}
          className="w-full bg-white border border-gray-200 rounded-xl p-4 text-left mb-3 disabled:opacity-50">
          <p className="text-sm font-medium text-gray-900">Je suis nouveau</p>
          <p className="text-xs text-gray-400 mt-0.5">L'appli vous guidera pas à pas, avec des explications.</p>
        </button>

        <button onClick={() => choisir('experimente')} disabled={envoi}
          className="w-full bg-white border border-gray-200 rounded-xl p-4 text-left disabled:opacity-50">
          <p className="text-sm font-medium text-gray-900">Je suis expérimenté</p>
          <p className="text-xs text-gray-400 mt-0.5">Un écran plus direct, sans explications superflues.</p>
        </button>
      </div>
    </div>
  );
};

export default NiveauAgronomeGate;